import $ from 'jquery';

export default {

	init() {
			$('.js-modal').click(function() {
				const id = $(this).data('trigger');
				$('#' + id).removeClass('hidden').addClass('flex');
				$('.js-close-modal').focus();
			});

			$('.js-close-modal').click(function() {
				const id = $(this).data('modal');
				$('#' + id).removeClass('flex').addClass('hidden').blur();
				$('.js-modal').focus();
			});
	}
};
